import * as yup from 'yup';


export const orderRefundValidationSchema = (orderItemsDetails) => (yup.object({
  shipping_amount: yup
    .number()
    .test('shipping_amount', 'Amount not valid', (value, context) => {
      if (!value) {
        return true;
      }

      const {base_shipping_amount, shipping_amount} = context.options.from[0].value;
      const shipping_refunded = context.options.from[0].value?.shipping_refunded || 0;
      return shipping_amount <= base_shipping_amount - shipping_refunded;
    }),
  adjustment_positive: yup
    .number(),
  adjustment_negative: yup
    .number(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        qty_ordered: yup.number(),
        qty_to_refund: yup
          .number()
          .min(0)
          .typeError('Invalid value')
          .test('qty_to_refund', 'Not allowed qty', (value, ctx) => {
            const itemIndex = ctx.options?.index;
            const {qty_ordered, qty_refunded, qty_to_refund} = ctx.options.from[1].value.items[itemIndex];

            if (!qty_to_refund) {
              return true;
            }

            if (!!orderItemsDetails?.[itemIndex].gift_cards.length) {
              const usedGiftCards = orderItemsDetails?.[itemIndex].gift_cards
                .filter((card) => card.init_balance !== card.balance).length;

              return (Number(qty_refunded) + Number(qty_to_refund) + usedGiftCards) <= Number(qty_ordered);
            }

            return (Number(qty_refunded) + Number(qty_to_refund)) <= Number(qty_ordered);
          })
      })
    )
}));
